module.exports = __webpack_public_path__ + "static/media/ic_switch_off.72217a54.svg";